import { Predicate } from '~/types/Predicate';

export const not =
  <T>(predicate: Predicate<T>) =>
  (x: T): boolean => {
    return !predicate(x);
  };
